import { render, staticRenderFns } from "./vTrialMasker.vue?vue&type=template&id=080b9dd1"
import script from "./vTrialMasker.vue?vue&type=script&lang=ts"
export * from "./vTrialMasker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports